// extracted by mini-css-extract-plugin
module.exports = {"NotificationCenter":"Notifications_NotificationCenter__CDRbw","NotificationCenter__List":"Notifications_NotificationCenter__List__eYwUD"};